import { ITables, TABLE_STATUS } from '../all-types'
import { defaultBillType } from '../redux-store'

export const TAKE_AWAY_TABLE_ID = '999'
export const MODIFY_BILL_TABLE_ID = 'modify-bill'

export const TakeAwayTableMock: ITables = {
  _id: TAKE_AWAY_TABLE_ID,
  tableNo: 999,
  tableName: 'Take-away Table',
  floorNo: 0,
  place: 'Terrace',
  capacity: 0,
  xAxis: 0,
  yAxis: 0,
  width: 0,
  height: 0,
  rotation: 0,
  placeId: 'place1',
  floorId: 'floor0',
  isActive: true,
  tableIcon: 'table-circle',
  tableImage: 'table5.jpg',
  tableColor: '#FFD733',
  chairColor: '#33FF8C',
  status: TABLE_STATUS.RESERVED,
  tableType: 'CIRCULAR',
  billSession: defaultBillType,
}
